import React from 'react'
import { observer } from 'mobx-react'
import OrderForm from '../order/OrderForm'
import PortOverview from '../order/PortOverview'
import { FinalStepLeft } from './FinalStepLeft'
import Logo from '../misc/Logo'
import StepNavigation from '../navigation/StepNavigation'
import CurrentStep from '../navigation/CurrentStep'
import Help from '../misc/Help'

function FinalStepMarkup () {

  return (
    <section className={'step final-step'}>
      <div className={'section-container'}>
        <header id={'port-configurator-header'} className={'configurator-header'}>
          <div className={'configurator-header__content'}>
            <Logo/>
            <StepNavigation/>
            <CurrentStep text={'Step '}/>
            <Help/>
          </div>
        </header>
        <div className={'final-step__grid'}>
          <div className={'final-step__left'}>
            <FinalStepLeft/>
          </div>

          <div className={'final-step__center grey-box'}>
            <OrderForm/>
          </div>

          <div className={'final-step__right'}>
            <PortOverview/>
          </div>
        </div>
      </div>
    </section>
  )
}

export default observer(FinalStepMarkup)
